import { WalletAddressType } from "@lib/types/Billing";
import { ConfigComponentProps } from "../../ConfigComponent";
import UsdtScanConfig from "./UsdtScanConfig";

export default function ScanConfigTabComponent(
  props: ConfigComponentProps & { tab: WalletAddressType },
) {
  switch (props.tab) {
    case WalletAddressType.USDT:
      return <UsdtScanConfig {...props} tab={props.tab} />;

    default:
      return <>scan config is not configured</>;
  }
}
